import { api } from '@/f1/service';
import _ from 'lodash'
import Language from './language';
import ruleI18n from '../rule.i18n'
import reg from '@/f1/reg'
import { VclFacebook } from 'vue-content-loading';
import 'flag-icon-css/css/flag-icon.css';
import Bell from 'vue-notification-bell'
import punycode from 'punycode/'
import codes from '@/f1/codes';

//restful api
import { webcastle_v2 as wc } from '@/f1/service/api';

//i18n_data
import i18n_toastr from './i18n_data'
import i18n_data from '@/component/i18n_data';

// const temp_i18n = {
//   'Country detected of user policy' : '사용자 정책의 국가 IP 기반 탐지',
//   'IPAddress detected of user policy' : '사용자 정책의 IP 주소 탐지',
//   'Host detected of user policy' : '호스트가 사용자 정책 탐지',
//   'Path detected of user policy' : '사용자 정책의 경로 탐지',
//   'Parameter detected of user policy' : '사용자 정책의 매개 변수 탐지',
// }

export default {
  props: ['id', 'only_view'],
  components : { Language, VclFacebook, Bell },
  computed: {
    exception_policy_name() {
      return this.exception_info.detail.file ? _.last(this.exception_info.detail.file.replace('.conf', '').split('/')) : ''
    },
    exception_policy_msg() {
      return this.exception_info.msg ? this.exception_info.msg : ''
    },
    exception_policy_id() {
      return this.exception_info.detail ? this.exception_info.detail.ruleId : ''
    },
    get_domain_list() {
      if(!this.model.agent || !this.model.agent.policy || !this.model.agent.policy.domains) { return [] }
      return _.map(this.model.agent.policy.domains, x => x.domain)
    },
    temp_i18n(){
      // console.log(i18n_data.temp_i18n[this.i18n])
      return i18n_data.temp_i18n[this.i18n]
    }
  }, // i18n 메세지 변환용.
  data : () => {
    return {
      // temp_i18n,
      codes,
      info_base_policy : { reason : '', is_show : false },
      is_exception : false,
      info_threat : false,
      loading : false,
      detections : [],
      ruleI18n,
      // info_xff : false,
      // info_risk : false,
      view_split_uri : false,
      view_split_request : false,
      parser_request : false,
      is_error :false,
      model : { uri: '', message : { messages : [], unique_id : "", time_stamp : "" } },
      exception_info :  { detail : {}, agent_id : 0, msg : '', domain : 'default', applied : [], is_exception : false },
      exception_info_modal_add : false,
      exception_info_modal_remove : false,
      detectInfo : '',
      current_lang : '',
      detectMsg : '',
      detectLang : '',
      detectLog : [],
      detectRule : [],
      detectPolicy : [],
      onOff : [],
      detectId : [],
      i18nmsg : '',
      m_Title : ''
    }
  },
  methods: {
    // check_disabled(x) {
    //   return _.indexOf(this.exception_info.applied, { domain : x }) > -1
    // },
    // i18n_msessage() {
    //   try {
    //     return ruleI18n[this.model.m_id][this.i18n]
    //   } catch (e) {
    //     console.log(e)
    //     return this.message().message
    //   }
    // },
    async copy(target='') {
      console.log("copy", target)
      await window.navigator.clipboard.writeText(target)
      document.execCommand("copy");
      this.$toastr.i(`${i18n_data._i18n_info.copy[this.i18n]}`);
    },
    quick_search(id) {
      if(this.check_custom({ tags : [] }, id)) { return alert(i18n_toastr._18n_alert.user_policy_not_supportist[this.i18n]()) }

      this.$parent.$emit('policy_id', id)
    },

    base_policy(msg) {
      this.info_base_policy.reason = msg
      this.info_base_policy.is_show = true
    },
    has_get_parameter() {
      try {
        if(!this.model.request) { return false }
        let x = this.model.request.split('?')
        if(x.length < 2) { return false }
        return true
      } catch (e) {
        console.log(e)
        return false
      }
    },
    parameter() {
      try {
        if(!this.has_get_parameter()) {
          return []
        }
        let x = Object.fromEntries(new URLSearchParams(this.model.uri.split('?')[1]))
        return  _.map(Object.keys(x), y => { return { key : y, value : x[y] } })
      } catch (e) {
        console.log(e)
        return []
      }
    },
    policy_domain() {
      try {
        let x = this.message()
        if(!x || !x.details) { return '' }
        let xx = x.details.file.split('/')
        return xx[xx.length - 1].replace('.conf', '')
      } catch (e) {
        console.log(e)
        return ''
      }
    },
    tags() {
      try {
        let x = this.message()
        // console.log('x', x, x.details)
        return x ? Object.values(x.details.tags) : []
      } catch (e) {
        console.log(e)
        return ''
      }
    },
    message() {
      try {
        // if(this.model.title) { return this.model.title }
        if(this.model.message.messages && this.model.message.messages.length < 1) { return '' }

        return this.model.message.messages[0]
      } catch (e) {
        console.log(e)
        return ''
      }
    },
    method(x) { return x && x.indexOf(' ') > -1 ? x.split(" ")[0] : '' },
    set_flag(x) { return `flag-icon flag-icon-${x.toLowerCase()}` },

    add_white : async function() {

      if(this.check_custom(this.exception_info.detail)) { return alert(i18n_toastr._18n_alert.user_policy_not_supportist[this.i18n]) }

      let version = Number(this.model.agent.version.replace(/v/, '').replace(/(\.)/gm, '').substring(0, 6));
      // if(version >= config.version) {
      //   return true
      // }

      // let version = Number(this.model.agent.version)
      let domain = Object.assign({})

      if(version < 202207) { domain.domain_list = this.exception_info.domain }
      else { domain.domain = this.policy_domain() }

      // let rs = await api.webcastle.WebCastle({ target : 'log', cmd : 'update.exception.add', body : Object.assign({}, { agent_id : this.exception_info.agent_id, rule_id : this.exception_info.detail.ruleId }, domain)})
      let rs = await wc.detect.exceptionAdd(Object.assign({}, { agent_id : this.exception_info.agent_id, rule_id : this.exception_info.detail.ruleId }, domain))
      if(rs.error) {
        return this.$toastr.e(rs.reason)
      }

      this.$toastr.s(`${i18n_toastr._i18n_success.exception[this.i18n]}`)
      console.log(this.$parent.$parent, 'reload')
      this.$parent.$emit("reload")
      this.get()
    },
    remove_white : async function() {
      if(this.check_custom(this.exception_info.detail)) { return alert(i18n_toastr._18n_alert.user_policy_not_supportist[this.i18n]) }

      let version = Number(this.model.agent.version.replace(/v/, '').replace(/(\.)/gm, '').substring(0, 6));

      // let version = Number(this.model.agent.version)
      let domain = Object.assign({})

      if(version < 202207) { domain.domain_list = this.exception_info.domain }
      else { domain.domain = this.policy_domain() }

      // let rs = await api.webcastle.WebCastle({ target : 'log', cmd : 'update.exception.remove', body : Object.assign({}, { agent_id : this.exception_info.agent_id, rule_id : this.exception_info.detail.ruleId }, domain) })
      let rs = await wc.detect.exceptionDelete(Object.assign({}, { agent_id : this.exception_info.agent_id, rule_id : this.exception_info.detail.ruleId }, domain))
      if(rs.error) {
        return this.$toastr.e(rs.reason)
      }
      this.$toastr.s(`${i18n_toastr._i18n_success.exception[this.i18n]}`)
      this.$parent.$emit("reload")
      this.get()
    },
    check_custom(message_detail='', id=0) {

      if(!message_detail) { return false }
      else if(id > 0) {
        return  _.filter((this.model.message.messages || []), x => Number(x.details.ruleId) == Number(id) && _.filter(x.details.tags, t => t.startsWith(`f1/${codes.WAF_MODE_CUSTOM.TEXT}`)).length > 0).length > 0
      }

      return _.filter((message_detail.tags || []), x => x.startsWith(`f1/${codes.WAF_MODE_CUSTOM.TEXT}`)).length > 0
    },
    split_uri_parser(x, len = window.innerWidth / 15) {
      let total = x.length
      let start = 0
      let rs = ""
      while (total > start) {
        rs += x.substr(start, len) + '\\\r\n'
        start += len
      }
      this.parser_request = true
      return rs.substr(0, rs.length - 4);
    },
    split_uri(uri) { return uri && uri.length > 100 ? this.split_uri_parser(uri) : uri },
    list() { this.$router.push({ name: 'webcastle_log'}); },
    async get({ id } = this.$route.params) {
      this.loading = true

      if(this.id && this.id > 0)  { id = this.id }

      if(!id) {
        this.loading = false
        console.log('detect.detail.vue', 'no have id', id);
        return
      }

      try {
        // let rs = await api.webcastle.WebCastle_Call('log', 'detail', { id : id })
        let rs = await wc.detect.detail({ id : id })
        if(rs.error) { return this.$toastr.e(`${i18n_data._i18n_error.load_failed[this.i18n]}` || '"load", "failed"'); }

        this.model = Object.assign({}, this.model, rs.body);

        try {//인코딩 데이터 유무 및 디코딩
          let encode = encodeURI(this.model.message)
          if(this.model.message != encode){//정상
            this.model.message = JSON.parse(this.model.message)
            // console.log(this.model.message)
          }else{//디코딩
            let message = atob(this.model.message);
            this.model.message = JSON.parse(message);
          }
        }
        catch (e) {
          console.log("json parser failed"); this.is_error = true;
        }

        this.detect_info(this.model); //기존 탐지 메시지

        this.version = this.detect_version(this.model);
        if(this.version < 202207){//하위 호환
          this.policy_switch(this.model)
        }

        this.i18nmsg = this.model.message.messages[0].message

        if(!this.i18nmsg){//msg 도 없을 경우
          this.i18nmsg = '-';
        }

        this.m_Title = i18n_toastr._18n_alert.user_policy_not_supportist[this.i18n]

        this.model.detect_cnt = 0
        this.model.block_cnt = 0
        this.model.agent.policy = JSON.parse(this.model.agent.policy)
        // const regex = /(Value: .* )/gm;

        _.forEach(this.model.message.messages, rule => {
          rule.is_info = rule.message.toLowerCase().indexOf('geoip') > -1
          rule.is_exception = false

          if(!rule.is_info && this.model.is_block) {
            // 탐지 되었을 수 있음
            // console.log('rule', _.filter(rule.details.tags, t => t == 'f1_detect'))

            rule.is_detect = _.filter(rule.details.tags, t => t == `f1/${codes.WAF_MODE_DETECTIONONLY.TEXT}`).length > 0
            rule.is_detect = !rule.is_detect ? _.startsWith(rule.message.toLowerCase(), '[detectiononly]') : rule.is_detect // 하위 호환
            rule.is_detect ? (this.model.detect_cnt += 1) : (this.model.block_cnt += 1)
          }

          try {
            // let m
            // while ((m = regex.exec(rule.details.match)) !== null) {

            //   if (m.index === regex.lastIndex) { regex.lastIndex++; }

            //   m.forEach((match, groupIndex) => {
            //     rule.value = match
            //     console.log(`Found match, group ${groupIndex}: ${match}`);
            //   });
            // }

            // https://github.com/mathiasbynens/punycode.js
            // 기본 라이브러리 punycode 는 사용 불가

            if(_.startsWith(this.model.target, 'xn--')) { this.model.target = punycode.toUnicode(this.model.target) }
            if(_.startsWith(this.model.host, 'xn--')) { this.model.host = punycode.toUnicode(this.model.host) }
          } catch (e) {
            console.log(e)
          }

          try {
            // 분기
            // let version = Number(this.model.agent.version)
            let version = this.detect_version(this.model)
            if(version < 202207) {
              rule.exception_list = _.map(_.filter(this.model.agent.policy.domains, x => _.indexOf(x.rule, rule.details.ruleId) > -1), x => {
                return { domain : x.domain, mode : x.mode }
              })
              console.log('rule.exception_list', rule.exception_list, this.policy_domain(), this.model.target)

              rule.is_exception = rule.exception_list.length > 0
              rule.is_exception_domain = _.filter(rule.exception_list, x => x.domain == this.model.target).length > 0
              rule.is_domain = this.model.target && _.findIndex(this.model.agent.policy.domains, x =>  x.domain == this.model.target) > -1
            } else {
              console.log('최신 버전', 2022.07)

              // rule.exception_list = _.compact(_.map(this.model.agent.policy.domains, x => {
              //   if(_.filter(x.custom_crs, c => _.filter(c.policy_list, { key : rule.details.ruleId }).length > 0).length > 0) {
              //     console.log(x.domain)
              //     rule.now_status = x.mode
              //     return { domain : x.domain, mode : x.mode }
              //   }
              //   return ''
              // }))
              // console.log('rule.exception_list', rule.exception_list, this.policy_domain(), this.model.target)

            }

          } catch (e) {
            console.log('checking exception', e)
          }

          // 신규 버전 현재 정책 사용 중 여부
          try {
            rule.domain = this.policy_domain()
            rule.now_status = null
            let index = _.findIndex(this.model.agent.policy.domains, { domain : rule.domain })

            if(index > -1) {
              // 존재하는 정책
              let is_flag = false

              // console.log(this.model.agent.policy.domains[index].custom_crs)

              //custom_crs 없을 경우
              if(!this.model.agent.policy.domains[index].custom_crs) {
                this.model.agent.policy.domains[index].custom_crs = [];
              }

              //custom_crs 있을 경우
              for (let i = 0; i < this.model.agent.policy.domains[index].custom_crs.length; i++) {
                if(is_flag) { break }

                const p = this.model.agent.policy.domains[index].custom_crs[i].policy_list;

                for (let l = 0; l < p.length; l++) {
                  const s = p[l];
                  // console.log('key', s.key, rule.details.ruleId)
                  if(s.key != rule.details.ruleId) { continue }

                  is_flag = true
                  rule.now_status = s.mode
                  // rule.now_policy = this.policy_domain()

                  // console.log('status', rule.now_status)

                  break
                }
              }
            }
          } catch (e) {
            console.log('checking exception', e)
          }
        })

        // if(this.model.message.messages) {
        //   this.model.message.messages = _.sortBy(this.model.message.messages, ['is_detect', 'details.severity']).reverse()
        // }
        if(!this.model.message.unique_id) { this.is_error = true }

        // 헤더 확인

        _.forEach(this.model.headers ? this.model.headers.split('\n') : [], line => {
          let ip = line.replace(/(x-forwarded-for:| )/ig, '')
          // console.log('ip', _.startsWith(line.toLowerCase(), 'x-forwarded-for') && reg.ip4.test(ip))
          _.startsWith(line.toLowerCase(), 'x-forwarded-for') && reg.ip4.test(ip) ? (this.model.xff = ip) : ''
        })


      } catch(e) {
        console.log(e); this.$toastr.e(e.data ? `${i18n_data._i18n_error.load_failed[this.i18n]}` :  e.data.message ? e.data.message : e.statusText) , this.list()
      } finally {
        this.loading = false
      }
    },
    detect_msg() {//탐지 메시지 고려
      let index = _.findIndex(this.model.message.messages);

      if(index > -1){
        for(let i = 0; i < this.model.message.messages.length; i++){
          this.detectMsg = this.model.message.messages[i].details
          this.current_lang = this.i18n
          this.detectLang = this.model.message

          this.detect_lang(this.current_lang, this.detectLang);
  
          let i18nDesc = this.detectMsg.i18n && this.detectMsg.i18n[this.current_lang] && this.detectMsg.i18n[this.current_lang].desc;
          let ruleI18nDesc = ruleI18n[this.detectMsg.ruleId] && ruleI18n[this.detectMsg.ruleId][this.current_lang];
          let tempI18nDesc = i18n_data.temp_i18n[this.i18n][`${i18nDesc}`];
          let i18nmsg = this.model.message.messages[i].message;
  
          if(i18nDesc) {
            if(tempI18nDesc == undefined || tempI18nDesc == null){
              switch (i18nDesc) {
                case '-' :
                  // ruleI18nDesc = (ruleI18nDesc ? ruleI18nDesc : i18nDesc)
                  ruleI18nDesc = (ruleI18nDesc ? ruleI18nDesc : (i18nmsg ? i18nmsg : i18nDesc))
                  this.detectInfo = ruleI18nDesc;
                  break;
                default :
                  this.detectInfo = i18nDesc;
                  break
              }
            }else{
              this.detectInfo = tempI18nDesc
            }
          }
          // this.detectInfo = ruleI18nDesc
          this.detectLog.push(this.detectInfo)
        }
        return this.detectLog
      }
    },
    detect_lang() {//언어 고려
      if(this.current_lang == 'JP' && !this.detectMsg.i18n['JP'] && !this.detectMsg.ruleId['JP']) {
        this.current_lang = 'EN'

        return this.current_lang
      }else{
        return this.current_lang
      }
    },
    detect_info() {
      this.detect_msg(this.model);
    },
    detect_version() {//에이전트 하위버전 고려
      let version = this.model.agent.version.replace(/v/, '')
      version = version.split('.').slice(0,2).join('')
      version = Number(version)

      return version
    },
    policy_switch(){//정책 끄고 켜기
      let policy = this.model.agent.policy
      policy = JSON.parse(policy)
      this.policy_ruleId(this.model)
      let ruleId = this.detectId

      //초기화
      this.detectPolicy = []
      this.detectRule = []
      this.onOff = []

      for(let i = 0; i < policy.domains.length; i++){//rule 만 추출
        let rule = policy.domains[i].rule
        this.detectPolicy.push(rule);

        for(let l = 0; l < this.detectPolicy.length; l++){//rule 중복제외 합치기
          let count = 0;
          if(count < this.detectPolicy.length){
            count = count + 1;

            let detectPolicy = this.detectPolicy[l].concat(this.detectPolicy[l+1])
            let detectRule = detectPolicy.filter((item, x) => detectPolicy.indexOf(item) === x);
            
            this.detectRule.push(detectRule)
          }
        }
      }

      for(let x = 0; x < ruleId.length; x++){//ruleId 확인
        let ri = this.detectRule[0].includes(ruleId[x]);
        this.onOff.push(ri)
      }
    },
    policy_ruleId(){//정책이 여러개일경우
      let index = _.findIndex(this.model.message.messages);
      if(index > -1){
        for(let i = 0; i < this.model.message.messages.length; i++){
          let id = this.model.message.messages[i].details.ruleId

          this.detectId.push(id)
        }
      }
    }
  },
  watch: {
    '$route' (to, from) { this.get(to.params, from); },
    // 'id' (to, from) { this.get(); }
  },
  created() { console.log('detect.detail.vue', 'created'); },
  destroyed() { console.log('detect.detail.vue', 'destroyed'); },
  mounted() {
    console.log('detect.detail.vue', 'mounted');
    this.get(this.$route.params);
  },
}
